<template>
    <div>
      <!-- Row top buttons -->
      <div class="row q-mb-lg">
        <div class="col-12">
          <!-- Button which opens a support dialog where the user can explain his question -->
          <SupportButton></SupportButton>
        </div>
      </div>

      <template v-for="(category, index) in help">
        <div :key="index">
          <div class="row q-mb-sm">
            <div class="full-width">
              <p class="card-title capitalize" v-text="index">
              </p>
              <div class="card-block no-padding scroll">
                <template v-for="(module, i) in category">
                  <q-list :key="i" class="custom-q-list accordion">

                    <!-- Help for genaral topics -->
                    <div v-if="index === 'general'">
                      <q-collapsible group="collapsibles" :duration="50" :label="module.title">
                        <div class="row">
                          <div class="col-12 q-pa-md q-pb-md">
                            <p v-html="module.intro"></p>
                            <router-link @click.native="toDetail(module.location)" class="text-weight-bold read-link" to="" icon="mdi mdi-chevron-right icon">
                              {{ $store.state.stringsStore.strings.read }} <q-icon size="large" name="mdi-chevron-right"/></router-link>
                          </div>
                        </div>
                      </q-collapsible>
                    </div>

                    <!-- Help for modules -->
                    <div v-else>
                      <q-collapsible group="collapsibles" :duration="50" :icon="mapIcon(module.icon)" :label="getString(module.label)">
                        <div class="row">
                          <template v-for="(page, i) in module.pages">
                            <div :key="i" class="col-6 q-pa-md q-pb-md" :class="{ 'col-6': (module.pages.length > 1), 'col-12': (module.pages.length === 1) }">
                              <p v-show="module.pages.length != '1'" class="text-weight-bold">{{ page.title }}</p>
                              <p v-html="page.intro"></p>
                              <router-link @click.native="toDetail(page.location)" class="text-weight-bold read-link" to="" icon="mdi mdi-chevron-right icon">
                              {{ $store.state.stringsStore.strings.read }} <q-icon size="large" name="mdi-chevron-right"/></router-link>
                            </div>
                          </template>
                        </div>
                      </q-collapsible>
                    </div>
                  </q-list>
                </template>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
</template>

<script>

// Imports
import _get from 'lodash.get';
import SupportButton from '../support/SupportButton.vue';

export default {
  created() {
    this.help = (this.$store.state.helpStore.help) ? this.$store.state.helpStore.help : null;
  },
  name: 'Help',
  components: {
    SupportButton,
  },
  data() {
    return {
      help: {},
      icons: {
        dashboard: 'dashboard',
        usergroups: 'people',
        developer: 'code',
        error: 'error_outline',
      },
    };
  },
  methods: {
    // Use lodash to fetch strings from store based on path string
    getString(path) {
      return _get(this.$store.state.stringsStore.strings, path);
    },
    mapIcon(icon) {
      return this.icons[icon] ? this.icons[icon] : this.icons.error;
    },
    toDetail(location) {
      /**
       * Because the API gives back a location on the dev-env we need to retrieve the last
       * value after the slash of this location and use it for our own routing
      */
      const last = location.split('/');
      this.$router.push(`/help/${last[last.length - 3]}/${last[last.length - 2]}`);
    },
  },
};
</script>

<style lang="stylus">
@import '~variables';
</style>
